export default {
    halloween: {
        label: "万圣节终身套餐优惠",
        eyebrow: "万圣节周 · 限时优惠",
        title: "只要糖果，不要恶作剧。",
        description: "Basic 终身套餐优惠 {basic}%，Advanced 终身套餐优惠 {advanced}%。",
        useCode: "使用优惠码",
        ends: "截至 {date}（含当天）· 仅限终身套餐",
        copied: "优惠码已复制，请在结账时使用。",
        copyFallback: "结账时输入 {code}。",
    },
    billing: {
        backToPlans: "查看所有套餐",
        completeTitle: "续费已确认",
        fixedPlan: "固定月度套餐",
        oneMonth: "增加一个月",
        oneTime: "一次性付款 · 不自动续费",
        currentExpiry: "当前使用期限至",
        estimatedExpiry: "续费后到期时间",
        keepTime: "保留所有剩余天数",
        keepTimeHint: "现在续费。新增月份从当前使用期限结束后开始；若已到期，则立即开始。",
        payNow: "续费摘要",
        paymentOptions: "支持 PayPal 及符合条件的银行卡或钱包。如需经销商选项，请选择更多付款方式。",
        acceptToPay: "请接受购买条款以启用付款方式。",
        resellerRenewalHint: "通过经销商续费前，请确认产品以及剩余天数如何处理。付款方式与可用性因经销商而异。",
        chooseAction: "选择要购买的内容",
        browsePlans: "所有套餐和礼物",
        endingSoon: "即将到期",
        ended: "使用期限已结束",
        fixedStatus: "固定月度套餐",
        autoStatus: "已启用自动续费",
        attention: "付款需要处理",
        checkStatus: "检查订阅状态",
        renewAction: "立即续费",
        expiryLabel: "使用期限至",
        keepDays: "续费不会损失剩余天数。",
        confirmedRefresh: "付款已确认。请刷新以查看新的到期日期，无需再次付款。",
        verifyHint: "上一次续费付款需要验证。请先检查同一订单，再进行其他付款。",
        verifyPayment: "验证上次付款",
        unavailable: "暂时无法获取账单状态，请在付款前刷新。",
        refresh: "刷新账单",
        manage: "在 PayPal 管理付款",
        failed: "自动续费需要处理。请在 PayPal 检查付款方式。PayPal 可能重试扣款；在此订阅仍可扣款时，请勿购买第二个套餐。",
        unknown: "无法确认订阅状态。再次付款前请先检查 PayPal。",
        automatic: "已启用自动续费。下次计划扣款：{date}。",
        expiring: "固定套餐将于 {date} 到期。提前续费不会损失剩余时间。",
        expired: "固定使用期限已结束，请续费以继续使用。",
        renewTitle: "续费 Dream {product}",
        renewHint: "增加一个固定月。这是一次性付款，不会创建自动续费订阅。",
        starts: "新增月份开始时间：{date}。",
        immediately: "付款成功后立即开始",
        price: "一个月 · US${price} · 立即付款",
        terms: "我同意购买条款。",
        blocked: "确认账单状态后才可续费。请先在 PayPal 管理现有订阅，以免重复付款。",
        success: "续费完成。使用期限至 {date}。",
        paymentError: "无法完成续费。请刷新账单状态。",
    },
    languages: {
        en: 'English',
        es: 'Español',
        zh: '中文',
        label: '语言',
        hint: '选择网站界面语言。',
    },
    common: {
        login: '登录',
        register: '注册',
        dashboard: '控制台',
        logout: '退出登录',
        save: '保存',
        cancel: '取消',
        continue: '继续',
        loading: '加载中…',
        renew: '续费',
        discord: 'Discord',
        getStarted: '立即开始',
        learnMore: '了解更多',
        back: '返回',
        apply: '应用',
        copy: '复制',
        done: '完成',
        view: '查看',
        close: '关闭',
        delete: '删除',
        create: '创建',
        search: '搜索',
        recommended: '推荐',
        monthly: '月付',
        lifetime: '终身',
        basic: 'Basic',
        advanced: 'Advanced',
        purchase: '购买',
        checkout: '结账',
        perMonth: '/月',
        lifetimePrice: '{price} 终身',
        confirm: '确认',
        submitting: '提交中…',
        sending: '发送中…',
        redeeming: '兑换中…',
        creating: '创建中…',
        redirecting: '跳转中…',
        oneMonth: '1 个月',
    },
    nav: {
        documentation: '文档',
        features: '功能',
        pricing: '价格',
        modules: '模块',
        updates: '更新',
        videos: '视频',
        media: '媒体',
    },
    sidebar: {
        dashboard: '控制台',
        purchase: '购买',
        download: '下载',
        modules: '模块',
        playerList: '玩家列表',
        configs: '配置',
        scripts: '脚本',
        referrals: '推广',
        reseller: '经销商',
        media: '媒体',
        tickets: '工单',
        guides: '教程',
        settings: '设置',
        manage: '管理',
        logout: '退出登录',
        license: '许可证',
        renew: '续费',
        expires: '{when}到期',
        expired: '已于 {when} 过期',
    },
    auth: {
        loginTitle: '登录',
        registerTitle: '注册',
        username: '用户名',
        password: '密码',
        email: '邮箱',
        confirmPassword: '确认密码',
        newPassword: '新密码',
        forgotPassword: '忘记密码？',
        noAccount: '还没有账号？',
        hasAccount: '已有账号？',
        twoFactorRequired: '{username} 需要两步验证',
        twoFactorCode: '6 位验证码',
        orRecovery: '或使用恢复码：',
        recoveryCode: '恢复码',
        backToLogin: '返回登录',
        verify: '验证',
        forgotTitle: '忘记密码',
        forgotHint: '输入邮箱，我们将发送重置链接。',
        sendReset: '发送重置链接',
        resetSent: '重置邮件已发送 — 请检查收件箱。',
        resetTitle: '重置密码',
        resetHint: '请输入你的新密码。',
        resetSubmit: '重置密码',
        resetSuccess: '成功！密码已更新。即将跳转到登录页。',
        cooldown: '你可以在 {minutes} 分钟后再次请求',
    },
    home: {
        brand: 'Dream Client',
        subtitle: '功能强大、可自定义的 Minecraft 客户端，通过浏览器管理——安全、持续更新，并为性能而设计。',
        whyTitle: '为什么选择 Dream',
        whySubtitle: '为操控、覆盖范围和对抗反作弊而打造。',
        featureControlTitle: '远程与游戏内控制',
        featureControlText:
            'Basic 完全通过浏览器 Web-GUI 控制。Advanced 增加外部与内部菜单，可在游戏内或任何地方调节模块。',
        featureVersionsTitle: '经典与现代版本',
        featureVersionsText:
            '支持 1.7–1.8、1.12.2，以及现代 Advanced 1.20.6–26.2——共享模块外加 1.20+ 专属功能。',
        featureSecureTitle: '持续更新与保护',
        featureSecureText: '针对当前反作弊持续更新，账户数据加密，支付安全——专注竞技，少操心。',
        pricingTitle: '价格与方案',
        pricingSubtitle: '与结账页相同价格 — 选择 Basic 或 Advanced 即可开始。',
        basicName: 'Dream Basic',
        advancedName: 'Dream Advanced',
        basicTag: 'Web-GUI',
        advancedTag: '外部 + 内部菜单',
        basicBullet1: '远程浏览器 Web-GUI',
        basicBullet2: 'Minecraft 1.7–1.8',
        basicBullet3: '21 个核心模块',
        basicBullet4: 'Windows 10 / 11',
        advancedBullet1: '外部 + 内部菜单',
        advancedBullet2: '1.7–1.8、1.12.2 与 1.20.6–26.2',
        advancedBullet3: '共享模块 + 1.20+ 专属模块',
        advancedBullet4: 'Windows 10 / 11',
        viewModules: '查看模块',
        getAdvanced: '获取 Advanced',
        resellerTeaser: '想转售？起步包约 $200，享 35% 折扣。',
        becomeReseller: '成为经销商',
        advancedChatTitle: "Dream 全局聊天",
        advancedChatSummary: "不同 Minecraft 服务器上的 Dream 用户共享同一个聊天频道。",
        advancedChatUsage: "在 Minecraft 聊天中输入",
        advancedChatNormal: "不以 .irc 开头的消息仍发送到当前 Minecraft 服务器的聊天。",
        advancedChatIdentity: "聊天消息格式为 [Dream] 角色/许可证 - 用户名: 消息。Dream 前缀为青色，服务器分配的徽章使用对应的角色颜色；你的 Dream 账号用户名和消息为白色且不加粗。徽章：Head Admin、Admin、Helper、Media、Lifetime 或 Advanced。",
        advancedChatControls: "在任一菜单中打开 UTIL / UTILITY → IRC CHAT，即可启用聊天或静音接收的消息。外部菜单显示后端连接状态，游戏内菜单还单独显示私密聊天是否就绪。Online 表示后端可访问。Enabled 默认开启，Mute 默认关闭。菜单与 .irc on/off/mute/unmute 使用同一组保存的设置。",
        advancedChatCommands: "命令",
        advancedChatPreview: "UTIL → IRC CHAT 提供 Enabled、Mute 和 Backend connection 状态。Online 表示后端可访问。在 Minecraft 聊天中输入 {command} 即可跨服务器交流；输入 {help} 查看命令。",
        modulesTitle: '模块',
        modulesSubtitle: '查看 Basic 与 Advanced 包含的内容。',
        videosTitle: '视频',
        videosSubtitle: '看看 Dream Client 的实战表现。',
    },
    guestCheckout: {
        eyebrow: '直接结账',
        title: '选择访问方案，几分钟内开始使用。',
        subtitle: '付款前无需创建账户。选择方案并安全付款，然后从确认页或邮件中创建 Dream 登录信息。',
        instant: '即时交付',
        mobileAdvancedPopular: 'Advanced · 最受欢迎',
        perMonthShort: '/月',
        accountAfter: '付款后创建账户',
        secure: 'PayPal 安全结账',
        chooseProduct: '选择 Dream 产品',
        chooseProductHint: '付款前比较支持范围。',
        from: '{price} 起',
        chooseAccess: '选择期限',
        monthly: '月付',
        lifetime: '终身',
        bestValue: '最超值',
        forOneMonth: '一个月',
        oneTime: '一次性付款',
        updatesIncluded: '持续产品更新',
        checkout: '安全结账',
        checkoutHint: '方案将绑定到你的邮箱。',
        signedInTitle: '你的账户已可购买',
        signedInBody: '前往控制台完整结账，使用现有优惠和付款方式。',
        openDashboardCheckout: '打开控制台结账',
        paymentComplete: '付款完成',
        successTitle: '访问权限已预留',
        successBody: '设置说明已发送至 {email}。你也可以立即创建账户。',
        createAccountNow: '创建我的账户',
        emailBackup: '同一安全链接也已发送到邮箱。',
        emailLabel: '访问权限发送到哪里？',
        emailPlaceholder: "you{'@'}example.com",
        emailHint: '仅用于收据、访问权限和账户设置。',
        processing: '正在确认付款并准备访问权限…',
        termsLead: '付款即表示你同意',
        termsLink: '服务条款',
        haveAccount: '已经是客户？',
        signInInstead: '登录并使用控制台结账',
        paypalSecure: '由 PayPal 处理',
        paypalPoweredBy: '技术支持：',
        noAccountFirst: '无需预先创建账户',
        moreMethods: '需要加密货币或其他方式？创建账户或登录后使用完整结账。',
        genericError: '无法启动结账，请重试。',
        paypalUnavailable: 'PayPal 暂时不可用，请使用账户结账。',
        validEmail: '继续前请输入有效邮箱。',
        cancelled: '付款已取消，未产生扣款。',
    },
    publicUpdates: {
        eyebrow: '持续开发',
        title: '近期更新。',
        live: '定期更新',
        subtitle: '购买前即可查看 Dream 更新日志中的真实版本、改进和修复。',
        version: 'Dream {version}',
        more: '另有 {count} 项更改',
        empty: '新的 Dream 更新会显示在这里。',
        cta: '每个方案都包含其支持版本的持续更新。',
        seePlans: '选择方案',
    },
    claim: {
        eyebrow: '访问权限已就绪',
        title: '创建 Dream 账户',
        subtitle: '购买已完成。请选择用于访问控制台和下载的登录信息。',
        purchasedFor: '购买邮箱',
        invalid: '此设置链接不完整或无效，请打开购买邮件中的链接。',
        error: '无法完成账户设置，请重试。',
        finishing: '正在创建账户…',
        submit: '创建账户并继续',
        note: '购买将绑定到此已验证邮箱。',
    },
    dashboard: {
        eyebrow: '控制台',
        welcome: '欢迎回来，{username}',
        sub: '账户概览、产品数据与最新更新日志。',
        joinDiscord: '加入 Discord',
        createChangelog: '创建更新日志',
        giveawaysTitle: '进行中的抽奖',
        giveawaysHint: '参与即有机会赢取许可证',
        enter: '参加',
        view: '查看',
        entered: '已参加',
        youWon: '你中奖了 — 点按查看奖品',
        expires: '{when}到期',
        drawn: '已于 {when} 开奖',
        entries: '{count} 人次',
        activityTitle: '启动与下载',
        activityHint: '本年度月度合计',
        changelogsTitle: '更新日志',
        userId: '用户 ID',
        totalUsers: '总用户数',
        totalLaunches: '总启动次数',
        totalDownloads: '总下载次数',
        versionBasic: 'Basic 版本',
        versionAdvanced: 'Advanced 版本',
        communityEyebrow: '社区',
        activityEyebrow: '活动',
        updatesEyebrow: '更新',
        toastLoadFailed: '加载信息失败',
    },
    download: {
        eyebrow: 'Dream 加载器',
        title: '准备你的客户端',
        sub: '选择 Dream 版本，设置加载器标识，并生成与你的许可证绑定的 Windows 版本。',
        licensed: '许可证已关联',
        editionEyebrow: '客户端版本',
        basicCopy: '浏览器 Web-GUI 控制 · Minecraft 1.7–1.8',
        advancedCopy: '外部 + 游戏内控制 · 支持现代版本',
        licenseLabel: '访问权限',
        licenseBound: '版本已绑定到你的账户',
        identityEyebrow: '加载器标识',
        identityTitle: '设置可执行文件',
        outputLabel: '生成的加载器',
        timestampCustom: '自定义时间戳',
        timestampRandom: '随机时间戳',
        devBuildHint: '仅限工作人员的通道',
        buildSummary: '可以生成',
        building: '正在生成加载器…',

        buildActivity: '正在生成你的加载器',
        buildProgressHint: '正在为你的账户和所选版本准备许可构建。',
        buildStageIdentity: '生成经过认证的分发记录',
        buildStageDos: '随机化 DOS 元数据',
        buildStageHeaders: '应用 COFF 和 PE 标头',
        buildStageChecksum: '写入校验和与时间戳',
        buildStageImports: '重排导入描述符',
        buildStageSeal: '封装许可可执行文件',
        buildDownload: '生成并下载',
        readinessEyebrow: '系统检查',
        appType: '应用类型',
        fileName: '可执行文件名',
        fileNameHint: '留空则默认为 AnyDesk.exe',
        fileNamePlaceholder: 'AnyDesk.exe',
        timestamp: '自定义时间戳',
        timestampHint: '可选 — 留空将使用随机时间戳',
        download: '下载',
        requirements: '要求',
        windows: 'Windows 10 / 11 x64',
        licenseNeeded: '需要有效的 Basic 或 Advanced 许可证',
        os: '系统',
        runtime: '运行库',
        osValue: 'Windows 10/11 x64',
        runtimeValue: 'VC++ Redistributable',
        devBuild: '下载开发版',
        notesEyebrow: '说明',
        notesTitle: '运行前须知',
        note1: '如果 Windows 提示缺少库，请安装 VC++ 运行库。',
        note2: '自定义文件名有助于让加载器与其他工具混在一起。',
        note3: '时间戳留空可获得随机构建时间。',
    },
    purchase: {
        eyebrow: '结账',
        title: '购买',
        sub: '选择产品和方案，然后付款。',
        upgradeEyebrow: '升级',
        upgradeTitle: '升级到 Advanced',
        upgradeSub: '你已拥有 Dream Basic。解锁 Advanced 模块、现代版本与游戏内菜单。',
        upgradeLead: '现代版本、游戏内菜单与额外模块 — Basic 仍然保留。',
        upgradePerk1: '支持 1.20.6–26.2',
        upgradePerk2: '外部 + 游戏内菜单',
        upgradePerk3: 'Advanced 战斗与实用功能',
        upgradePriceLabel: '终身 · 账户优惠 {percent}%',
        payUpgrade: '支付升级',
        continueToPay: '继续付款',
        seeWhatsNew: '查看新增内容',
        buyAsGift: '购买礼物',
        becomeReseller: '成为经销商',
        openReseller: '打开经销商面板',
        giftLinks: '未兑换的礼物链接',
        yourGifts: '你的礼物',
        copyLink: '复制链接',
        allSetTitle: '已全部就绪',
        allSetSub: '你已拥有 Basic 和 Advanced。可开启{gift}送给好友，或使用{reseller}销售密钥。',
        product: '产品',
        plan: '方案',
        payNow: '立即支付',
        upgradeTotal: '升级合计',
        total: '合计',
        payCrypto: '加密货币支付',
        moreMethods: '更多支付方式',
        viewModules: '查看模块',
        partnerLabel: '精选合作伙伴',
        partnerTitle: '需要 Minecraft 账号？',
        partnerBody: '实惠的 NFA 与 MFA 账号，包括带有 Hypixel 等级或 Donut SMP 余额的账号。',
        partnerCta: '查看商店',
        partnerAria: '访问 fernan.club，精选 Minecraft 账号商店',
        acceptTerms: '接受条款',
        viewTerms: '查看条款',
        discountReferralKey: '折扣、推广或许可证密钥',
        discountCode: '折扣码',
        referralCode: '推广码',
        redeemKey: '兑换许可证密钥',
        redeem: '兑换',
        giftMonthlyNote: '礼物月付许可证包含 1 个月使用权。',
        upgradeLocked: '从 Basic 升级时产品已锁定为 Advanced。',
        upgradeFromBasic: '从 Basic 升级 · {tag}',
        keepBasicNote: '你正在从 Basic 升级。现有 Basic 访问仍然有效。',
        lifetimeUpgradeDiscount: 'Basic 终身升级 · {percent}% 优惠',
        discountApplied: '已应用 {percent}% 折扣',
        webGuiTag: 'Web-GUI · Minecraft 1.7–1.8',
        advancedTag: '外部 + 内部菜单 · 1.7–26.2',
        fixedMonths: '购买固定月数（不自动续费）',
        giftComplete: '购买完成',
        giftReady: '礼物已可分享',
        giftProcessing: '礼物正在生成中。若链接未出现，请稍后在「我的礼物」中查看。',
        giftShareHint: '在 Discord 发送链接。好友登录后兑换。我们也已把详情发到你的邮箱。',
        redeemLink: '兑换链接',
        backupKey: '备用密钥',
        copyShareLink: '复制分享链接',
        fixedMonthsHint: '访问权限在所选月数结束后到期 — 需要重新购买。',
        agreementEyebrow: '结账前',
        termsTitle: '服务条款',
        termsLead: '购买 Dream 前必须同意我们的服务条款。',
        toastGiftCopied: '礼物链接已复制',
        toastCopyLinkFailed: '无法复制链接',
        toastKeyCopied: '密钥已复制',
        toastCopyKeyFailed: '无法复制密钥',
        toastKeyRedeemed: '密钥兑换成功',
        toastSomethingWrong: '出了点问题',
        toastAssistantSelected: '已选择 Dream {product} · {plan}{gift}',
        toastGiftSuffix: ' · 礼物',
        cryptoNoteTitle: '加密货币说明',

        cryptoNoteBody: '请注意：使用加密货币支付时，访问权限可能不会立即到账。交易处理完成后你会收到产品。若 24 小时内未收到，请提交工单。在交易待处理时请勿再次购买，否则可能导致资金损失。',
    },
    settings: {
        eyebrow: '账户',
        title: '设置',
        sub: '管理你的 Dream 账户、安全与订阅。',
        languageEyebrow: '偏好',
        languageTitle: '语言',
        languageHint: '选择网站界面语言。不会更改法律条款文本。',
        languageSaved: '语言已更新。',
        hardware: '硬件',
        profile: '资料',
        security: '安全',
        staff: '员工',
        hwidTitle: 'HWID',
        hwidText: '看到 {auth} 时运行 {dream} 复制 HWID，然后粘贴到这里。',
        lastUpdated: '上次更新',
        hwidSuccess: 'HWID 已更新。现在可以访问 Dream。',
        usernameTitle: '用户名',
        usernameText: '更改用于登录的用户名。',
        usernameSuccess: '用户名已更新。',
        emailTitle: '邮箱',
        emailText: '从旧系统迁移时需要。更新后你会收到验证邮件。',
        emailSuccess: '邮箱已更新。请在再次使用 Dream 前查收验证链接。',
        updateEmail: '更新邮箱',
        passwordTitle: '更改密码',
        oldPassword: '旧密码',
        updateHwid: '更新 HWID',
        hwidPlaceholder: 'HWID',
        updateUsername: '更新用户名',
        changePassword: '更改密码',
        discordTitle: '绑定 Discord',
        discordText: '粘贴你的 Discord ID，以便在分配给你的工单回复时收到提醒。',
        discordPlaceholder: 'Discord ID',
        updateDiscord: '更新 Discord ID',
        twoFactorTitle: '两步验证',
        twoFactorHint: '添加身份验证器应用代码，为登录增加一层安全保障。',
        twoFactorDisabled: '两步验证当前已{status}。',
        twoFactorEnabled: '两步验证当前已{status}。',
        twoFactorStatusDisabled: '关闭',
        twoFactorStatusEnabled: '开启',
        brandDream: 'Dream',
        notAuthenticated: 'Not Authenticated',
        enable2fa: '启用两步验证',
        disable2fa: '关闭两步验证',
        step1Qr: '步骤 1：扫描二维码',
        step1QrHint: '使用 Google Authenticator、Authy 等扫描：',
        step2Code: '步骤 2：输入验证码',
        step2CodeHint: '输入应用中的 6 位验证码：',
        verifyEnable: '验证并启用',
        viewRecovery: '查看恢复码',
        generateRecovery: '生成新恢复码',
        recoveryTitle: '恢复码',
        recoveryHint: '请妥善保存。丢失设备时可用每个恢复码解锁账户。',
        hideRecovery: '隐藏恢复码',
        disable2faTitle: '关闭两步验证',
        disable2faHint: '输入密码以及两步验证码或恢复码：',
        twoFactorOrRecovery: '两步验证码或恢复码',
        never: '从未',
        dangerZone: '危险区域',
        subscriptionsTitle: '订阅与账户',
        cancelSubscription: '取消订阅',
        cancelBasicTitle: '取消 Basic PayPal 订阅',
        cancelBasicText: '当前周期结束后将失去 Basic 访问权限。',
        cancelBasic: '取消 Basic',
        cancelAdvancedTitle: '取消 Advanced PayPal 订阅',
        cancelAdvancedText: '当前周期结束后将失去 Advanced 访问权限。',
        cancelAdvanced: '取消 Advanced',
        deleteAccount: '删除账户',
        deleteAccountText: '永久删除你的 Dream 账户。此操作无法撤销。',
        toastPasswordUpdated: '密码已更新',
        toastPasswordFailed: '更新密码失败',
        toastVerifyFailed: '发送验证失败',
        toastHwidUpdated: 'HWID 已更新',
        toastHwidFailed: '更改 HWID 失败',
        toastUsernameUpdated: '用户名已更新',
        toastUsernameFailed: '更改用户名失败',
        toastDiscordUpdated: 'Discord ID 已更新',
        toastDiscordFailed: '更改 Discord ID 失败',
        toastAccountDeleted: '你的账户已删除',
        toastAccountDeleteFailed: '删除账户失败',
        toastSubCancelledBasic: '你的 Basic 订阅已取消',
        toastSubCancelledAdvanced: '你的 Advanced 订阅已取消',
        toastSubCancelFailed: '取消订阅失败',
        toast2faSecretFailed: '生成两步验证密钥失败',
        toast2faEnabled: '已为账户启用两步验证',
        toast2faEnableFailed: '启用两步验证失败',
        toast2faDisabled: '已为账户关闭两步验证',
        toast2faDisableFailed: '关闭两步验证失败',
        toastRecoveryViewFailed: '查看恢复码失败',
        toastRecoveryGenerated: '已生成新恢复码',
        toastRecoveryGenerateFailed: '生成恢复码失败',

        dialogPasswordTitle: '更改密码',
        dialogPasswordText: '确定要更改密码吗？',
        dialogDisable2faTitle: '关闭两步验证',
        dialogDisable2faText: '确定要关闭两步验证吗？',
        dialogRecoveryTitle: '生成新恢复码',
        dialogRecoveryText: '这将生成新的恢复码并使现有恢复码失效。确定吗？',
        dialogDeleteTitle: '输入密码',
        dialogDeleteText: '请输入密码以删除账户',
        dialogCancelSubTitle: '输入密码',
        dialogCancelSubText: '请输入密码以取消此订阅',
    },
    scripts: {
        ui: {
            "details": "查看详情",
            "deleteScript": "删除脚本",
            "deleting": "正在删除…",
            "delete": "删除",
            "reading": "正在读取脚本…",
            "startSource": "先选择你的 .luau 文件",
            "prefill": "从 dream.module 自动填写信息；你可以修改下方所有内容。",
            "sourceHint": "UTF-8 · 最大 256 KiB。文件仅在本地读取，不会执行。",
            "idHint": "使用 author.module 格式；两侧各需至少 2 个小写字母、数字、_ 或 -。",
            "nameHint": "3–64 个字符。",
            "versionHint": "语义化版本，如 1.0.0 或 1.0.0-beta.1（最多 32 个字符）。",
            "summaryHint": "10–240 个字符。",
            "descriptionHint": "20–5,000 个字符。",
            "visibility": "可见性",
            "chooseVisibility": "选择此版本的发布范围",
            "privateReadyHint": "私有版本通过自动检查后即可在你的加载器中使用。",
            "ownerOnly": "仅所有者",
            "moderated": "需要审核",
            "private": "私有",
            "privateHint": "仅你可以安装，无需审核。",
            "marketplaceHint": "工作人员批准前将保持待审核状态。",
            "chooseRuntime": "选择一个客户端系列",
            "runtimeHint": "每个发布版本只支持一个客户端系列。",
            "required": "必选",
            "chooseCapabilities": "选择脚本使用的功能",
            "capabilityHint": "游戏操作权限将在审核时检查。",
            "privateNotice": "通过自动检查后，此版本仅在你的加载器中可用。",
            "localNotice": "此市场版本将保留在本地调试审核队列中。",
            "publicNotice": "市场版本在等待审核期间仍仅对你可见。",
            "uploadPrivate": "上传私有脚本",
            "submitting": "正在提交…",
            "submitMarketplace": "提交到市场",
            "hideProfiles": "隐藏云端配置",
            "cloudProfiles": "云端配置",
            "noProfiles": "此脚本没有已保存的云端配置。",
            "noPersonalProfiles": "你还没有为此脚本保存云端配置。",
            "enabled": "已启用",
            "disabled": "已停用",
            "checksPassed": "自动检查已通过",
            "validationReport": "验证报告",
            "submittedSource": "已提交的 Luau 源码",
            "openReview": "展开查看",
            "sourceUnavailable": "源码不可用。",
            "author": "作者",
            "about": "关于此脚本",
            "personalStorage": "个人存储",
            "myProfiles": "我的云端配置",
            "close": "关闭",
            "unavailable": "不可用",
            "on": "开",
            "off": "关",
            "unknown": "未知",
            "privateReady": "私有 · 就绪",
            "marketplacePending": "市场 · 待审核",
            "marketplacePublished": "市场 · 已发布",
            "marketplaceRejected": "市场 · 已拒绝",
            "validationPassed": "自动验证已通过。",
            "submittedMarketplace": "已提交版本进行市场审核。",
            "privateUploaded": "私有脚本已通过验证并添加到你的加载器。",
            "localSubmitted": "市场版本已提交到本地审核队列。",
            "correctFields": "请修正标出的上传字段。",
            "fileSelected": "文件已选择。已保留现有信息，请补全下方缺失的字段。",
            "readError": "无法读取源码。请保存为 UTF-8 文本后重新选择。",
            "fileRange": "请选择大小在 1 字节至 256 KiB 之间的 .luau 文件。",
            "sourceRange": "源码文件大小必须在 1 字节至 256 KiB 之间。",
            "chooseSource": "请选择一个 .luau 源码文件。",
            "sourceExtension": "仅接受 .luau 源码文件。",
            "invalidName": "显示名称必须为 3–64 个字符。",
            "invalidSummary": "简介必须为 10–240 个字符。",
            "invalidDescription": "描述必须为 20–5,000 个字符。",
            "invalidRuntime": "请仅选择一个 Minecraft 客户端系列。",
            "invalidVisibility": "请选择私有或市场可见性。",
            "invalidCapabilities": "最多选择 7 项支持的功能，不能重复。",
            "invalidId": "使用 author.module 格式；两侧各需至少 2 个小写字母、数字、下划线或连字符。",
            "invalidVersion": "请使用语义化版本，如 1.0.0 或 1.0.0-beta.1（最多 32 个字符）。",
            "deleteProfile": "删除云端配置",
            "deleteDreamScript": "删除 Dream 脚本",
            "localListing": "本地调试列表",
            "productionListing": "生产列表",
            "by": "作者：{name}",
            "more": "另有 {count} 项",
            "selected": "已选择 {count} 项",
            "saved": "已保存 {count} 个",
            "savedValues": "已保存 {count} 个值",
            "pending": "{count} 个待审核",
            "revision": "v{version} · 修订 {revision}",
            "deleteNamed": "删除 {name}",
            "deleteProfileNamed": "删除云端配置 {name}",
            "deleted": "已删除 {name}。",
            "confirmProfile": "要从 {script} 删除“{name}”吗？此操作无法撤销。",
            "confirmScript": "要删除 {id} 吗？这将永久删除{channel}中的所有版本和已保存配置。另一个渠道不会受影响。",
            "imported": "已填写：{fields}。上传前请检查版本、客户端系列和功能权限。",
            "worldData": "玩家与世界数据",
            "worldDataHint": "读取安全的游戏状态快照",
            "drawing": "绘制",
            "drawingHint": "文字、线条与形状",
            "playerControls": "玩家控制",
            "playerControlsHint": "疾跑与移动按键",
            "viewControl": "视角控制",
            "viewControlHint": "水平与垂直转向",
            "combatActions": "战斗操作",
            "combatActionsHint": "攻击或挥手",
            "hotbarControl": "快捷栏控制",
            "hotbarControlHint": "选择第 1–9 格",
            "worldInteraction": "世界交互",
            "worldInteractionHint": "安全地与方块交互"
        },
        eyebrow: 'Advanced 扩展',
        title: 'Dream Scripts',
        subtitle: '浏览已审核模块、发布源码、在加载器中管理云端配置，并学习安全 API。',
        memoryOnly: '仅内存客户端',
        memoryOnlyHint: '每次会话重新获取；脚本和配置不会写入磁盘。',
        marketplace: '市场', mine: '我的脚本', docs: '文档', review: '审核',
        search: '搜索脚本', allRuntimes: '所有版本', modern: '现代版 1.20+', legacy: '旧版 1.7.10 / 1.8.9 / 1.12.2',
        mostLoaded: '最多加载', newest: '最新', refresh: '刷新', loads: '次加载',
        loaderOnly: '请在 Dream 加载器中以内存方式运行。',
        emptyMarketplace: '没有已审核脚本', emptyMarketplaceHint: '请更换筛选条件或发布第一个模块。',
        publishEyebrow: '作者工具', publishTitle: '提交版本', scriptId: '脚本 ID', name: '名称',
        version: '版本', summary: '摘要', description: '描述', compatibility: '兼容性', permissions: '权限',
        chooseSource: '选择一个 .luau 源文件', reviewNotice: '每个版本在工作人员批准前均为私有。',
        uploading: '上传中…', submitReview: '提交审核', yourScriptsEyebrow: '发布历史', yourScripts: '你的脚本',
        noUploads: '你还没有上传脚本。', submitted: '版本已提交审核。',
        reviewEyebrow: '内容审核', reviewTitle: '待审核版本', reviewNote: '审核备注', approve: '批准', reject: '拒绝',
        reviewEmpty: '没有待审核版本。', reviewSaved: '审核已保存。',
        docsEyebrow: 'API 版本 1', docsTitle: '构建安全的 Dream 模块',
        docsIntro: 'Luau 通过 legacy 与 modern 共用的小型权限 API 运行。脚本无法获得本机句柄或操作系统访问权限。',
        genericError: '脚本请求失败。',
    },
    configs: {
        eyebrow: '预设',
        title: '配置',
        sub: '按所用模块浏览预设，为最佳方案投票，一键应用。',
        showing: '显示',
        publish: '发布',
        filterAll: '全部',
        filterMine: '我的',
        filterPrivate: '私有',
        filterPublic: '公开',
        filterOfficial: '官方',
        sortTop: '热门',
        sortNew: '最新',
        versionModern: '1.20+',
        versionLegacy: '1.7–1.12',
        upvote: '赞成',
        downvote: '反对',
        moduleCount: '{n} 个模块',
        noModules: '没有自定义模块',
        previewSettings: '预览设置',
        hideSettings: '收起设置',
        previewTitle: '配置设置',
        previewSummary: '{modules} 个模块 · {settings} 项已修改设置',
        previewReadOnly: '只读',
        settingCount: '{n} 项设置',
        customizedCount: '{n} 项自定义',
        enabled: '已启用',
        boundTo: '按键：{key}',
        disabled: '已禁用',
        notSet: '未设置',
        noModuleSettings: '无其他设置',
        noPreviewSettings: '没有可预览的已修改模块设置或按键绑定。',
        use: '使用',
        delete: '删除配置',
        emptyTitle: '未找到配置',
        emptySub: '尝试其他筛选，或发布你当前的设置供他人使用。',
        publishCta: '发布配置',
        publishTitle: '发布配置',
        publishSub: '分享你当前的 Dream 设置。私有仅自己可见；公开所有人可见。官方仅限员工。',
        backToList: '返回配置列表',
        visibility: '可见性',
        visibilityHint: '选择谁能在浏览器中看到此配置。',
        nameLabel: '配置名称',
        nameHint: '5–50 个字符',
        namePlaceholder: '配置名称',
        descriptionLabel: '描述',
        descriptionHint: '10–300 个字符 — 服务器、玩法、备注',
        descriptionPlaceholder: '配置描述',
        publishSuccess: '配置发布成功。',
        publishing: '发布中…',
        tipsEyebrow: '提示',
        tipsTitle: '发布前',
        tip1: '使用清晰名称，方便他人快速找到。',
        tip2: '在描述中写明服务器或玩法风格。',
        tip3: '私有配置仅你可见。',
        tip4: '发布会快照你当前的模块设置。',
        toastLoadFailed: '加载配置失败',
        toastOwnVote: '不能给自己的配置投票',
        toastVoteFailed: '投票失败',
        dialogUseTitle: '使用配置',
        dialogUseText: '确定要使用此配置吗？这将覆盖你现有的配置。',
        toastApplied: '配置已应用',
        toastUseFailed: '使用配置失败',
        dialogDeleteTitle: '删除配置',
        dialogDeleteText: '确定要删除此配置吗？',
        toastDeleted: '配置已删除',
        toastDeleteFailed: '删除配置失败',
    },
    supportAssistant: {
        eyebrow: 'Dream 支持助手', title: 'Dream 助手', hint: '创建工单前，可先询问 Dream Basic 或 Advanced。', launchHint: '快速了解配置、模块、HWID、媒体和购买信息', headerHint: 'Dream 支持 · 答案可能由自动化生成',
        clear: '清除对话', collapse: '关闭助手', greeting: '你好！我可以帮你查找 Dream 设置和故障排查步骤。请提问或选择下面的主题。',
        examplesLabel: '示例问题', examples: '试试这些问题：', exampleConfig: '加载配置', exampleModules: '查找模块设置', exampleHwid: '修复无效 HWID', exampleMedia: '媒体申请', examplePurchase: '购买选项',
        promptConfig: '如何为 Dream 加载配置？', promptModules: '在哪里可以找到模块列表和模块设置？', promptHwid: '我遇到 HWID 无效错误。应该检查什么？', promptMedia: '如何提交媒体申请？', promptPurchase: 'Dream 有哪些购买选项？',
        historyLabel: '对话', you: '你', assistant: 'Dream 助手', handoff: '还需要帮助吗？', createTicket: '创建支持工单', openSource: '打开{title}',
        loading: '正在思考…', error: '支持助手暂时不可用。请重试或创建工单。',
        productLabel: 'Dream 产品', productAll: '全部', questionLabel: '你的问题', placeholder: '输入问题…',
        ask: '发送', privacy: 'Enter 发送 · Shift + Enter 换行。请勿填写密码、许可证密钥、付款信息或其他机密。对话仅保存在当前页面会话中。',
    },
    tickets: {
        eyebrow: '支持',
        title: '工单',
        sub: '创建并跟踪支持工单。选择正确的类别，以便工作人员更快帮助你。',
        showing: '显示',
        department: '部门',
        create: '创建工单',
        submit: '提交工单',
        titlePlaceholder: '工单标题',
        detailHint: '请在下方文本框中填写工单详情。描述越详细，我们越能更快帮你解决。',
        bodyPlaceholder: '在此开始输入工单内容…',
        replyPlaceholder: '回复',
        send: '发送',
        replied: '已回复',
        createdLabel: '已创建',
        refresh: '刷新',
        refreshAria: '刷新工单',
        filterAria: '工单筛选',
        showClosed: '显示已关闭工单',
        assignedBadge: '已分配',
        filterAny: '全部',
        filterMine: '我的',
        filterDepartment: '部门',
        filterAssigned: '已分配',
        filterUnassigned: '未分配',
        emptyTitle: '未找到工单',
        emptySub: '尝试其他筛选条件，或创建新的支持工单。',
        deleteAria: '删除工单',
        deleteReplyAria: '删除回复',
        allTickets: '全部工单',
        assignedTo: '分配给 {username}',
        ticketNumber: '工单 #{id}',
        loadingTicket: '正在加载工单…',
        assignStaff: '分配客服',
        details: '详情',
        labelTitle: '标题',
        labelCategory: '类别',
        labelCreator: '创建者',
        labelCreated: '创建时间',
        labelAssigned: '分配给',
        unassigned: '未分配',
        stateOpen: '开放',
        stateClosed: '已关闭',
        stateLocked: '已锁定',
        confirmCloseTitle: '确认关闭',
        confirmCloseText: '确定要关闭此工单吗？工单关闭后无法重新打开，你需要创建新的工单。',
        confirmDeleteTitle: '确认删除',
        confirmDeleteText: '确定要删除此工单吗？',
        confirmDeleteReplyText: '确定要删除此回复吗？',
        loadFailed: '加载工单失败',
        loadTicketFailed: '无法加载工单',
        closeFailed: '关闭工单失败',
        deleteFailed: '删除工单失败',
        loadRepliesFailed: '加载回复失败',
        sendReplyFailed: '发送回复失败',
        deleteReplyFailed: '删除回复失败',
        deptTechnical: '技术支持',
        deptSales: '销售',
        deptDetections: '检测',
        deptSuggestions: '建议',
        deptMedia: '媒体申请',
        deptOther: '其他',
    },
    reseller: {
        eyebrow: '经销商面板',
        title: '许可证中心',
        sub: '批量发票、支付跟踪与密钥解锁 — 一站完成。',
        discount: '你的折扣',
        unusedKeys: '未使用密钥',
        redeemed: '已兑换',
        keysInCart: '购物车密钥',
        storefront: '品牌兑换页',
        copyLink: '复制链接',
        tabPurchase: '购买',
        tabInvoices: '发票',
        tabStock: '库存',
        tabTools: '工具',
        bulkPurchase: '批量购买',
        bulkPurchaseSub: '在一张发票中混合多种方案与套餐。',
        licenseN: '许可证 {n}',
        remove: '移除',
        plan: '方案',
        package: '套餐',
        quantity: '数量',
        addLicenseType: '添加另一种许可证类型',
        basicMonthly: 'Basic 月付',
        basicLifetime: 'Basic 终身',
        advancedMonthly: 'Advanced 月付',
        advancedLifetime: 'Advanced 终身',
        orderSummary: '订单摘要',
        readyToInvoice: '准备开票',
        total: '合计',
        includesDiscount: '已含 {percent}% 经销商折扣',
        listPriceHint: '上方单价为折扣前的标价。',
        createInvoice: '创建发票',
        invoicesTitle: '发票',
        invoicesSub: '已支付的发票可解锁对应许可证密钥。',
        colId: 'ID',
        colDetails: '详情',
        colQuantity: '数量',
        colStatus: '状态',
        colDate: '日期',
        colActions: '操作',
        paid: '已支付',
        unpaid: '未支付',
        pageN: '第 {n} 页',
        prev: '上一页',
        next: '下一页',
        keyStock: '密钥库存',
        keyStockSub: '来自已支付发票生成的密钥。',
        exportUnused: '导出未使用',
        filterAll: '全部',
        filterUnused: '未使用',
        filterUsed: '已使用',
        anyType: '任意类型',
        anyPlan: '任意方案',
        colKey: '密钥',
        colType: '类型',
        colPlan: '方案',
        used: '已使用',
        unused: '未使用',
        stockTotal: '共 {n} 个',
        salesAnalytics: '销售分析',
        salesAnalyticsSub: '按标价估算利润（你的批发折扣 {percent}%）· 近 30 天',
        allTimeProfit: '累计利润',
        allTimeProfitDetail: "· 已花费 {'$'}{spend} · {keys} 个密钥",
        profit30d: '利润（30天）',
        profitHint: '来自已兑换密钥（按标价）',
        openMargin: '潜在利润',
        openMarginHint: '未使用库存按标价售出',
        spent30d: '花费（30天）',
        sellThrough: '售出率',
        sellThroughHint: '购买 {n} · 30天',
        salesChartAria: '近 30 天估算利润与批发花费',
        salesChartEmpty: '暂无活动 — 客户兑换密钥后才会显示利润（按标价估算）。',
        purchaseMix: '购买构成（30天）',
        mixChartAria: '按产品类型购买的密钥数',
        mixChartEmpty: '暂无购买',
        marginCalculator: '利润计算器',
        marginCalculatorSub: '你享有标价 {percent}% 折扣。输入售价以查看利润。',
        product: '产品',
        sellPrice: '你的售价（$）',
        matchList: '匹配标价',
        breakEven: '保本价',
        list: '标价',
        yourCost: '你的成本',
        profitPerKey: '每密钥利润',
        marginPercentLabel: '{n}% 利润率',
        redemptions: '兑换',
        redemptionsSub: '库存密钥每日兑换 · 近 30 天',
        redemptionsTotal: '合计',
        bestDay: '最佳日',
        activeDays: '活跃天数',
        redemptionsChartAria: '近 30 天兑换情况',
        redemptionsChartEmpty: '暂无兑换 — 客户使用密钥后图表会更新。',
        invoiceN: '发票 #{id}',
        status: '状态',
        details: '详情',
        payInvoice: '支付发票',
        sandboxMode: '沙盒模式已启用',
        payWithCrypto: '加密货币支付',
        keys: '密钥',
        toastLoadStockFailed: '加载库存失败',
        toastCopiedUnused: '已复制 {count} 个未使用密钥',
        toastExportFailed: '导出失败',
        toastCopied: '已复制',
        toastCopyFailed: '复制失败',
        toastInvoiceCreated: '发票创建成功',
        toastInvoiceCreateFailed: '创建发票失败',
        deleteInvoiceTitle: '删除发票',
        deleteInvoiceConfirm: '确定要删除此发票吗？',
        toastInvoiceDeleted: '发票已删除',
        toastInvoiceDeleteFailed: '删除发票失败',
        toastLoadInvoiceFailed: '加载发票详情失败',
        toastPaymentCreateFailed: '创建支付失败',
        toastPaymentSuccess: '支付成功！密钥已生成。',
        toastPaymentVerifyFailed: '支付验证失败',
        cryptoPaymentTitle: '加密货币支付',
        cryptoPaymentConfirm: '使用加密货币支付？',
        toastCryptoInitiated: '已发起加密货币支付…',
        toastPaymentUrlFailed: '获取支付链接失败',
        toastCryptoCreateFailed: '创建加密货币支付失败',
        chartRedemptions: '兑换',
        chartRedeemed: '已兑换 {n}',
        chartProfit: '利润 ($)',
        chartSpend: '花费 ($)',
        chartKeysBought: '购买密钥：{n}',
        chartKeys: '密钥',
        chartKeysCount: '{n} 个密钥',
    },
    guides: {
        eyebrow: '帮助',
        title: '教程',
        sub: '安装、绕过与排障文章。',
        search: '搜索教程',
        showing: '显示',
        create: '创建教程',
        view: '查看教程',
        emptyTitle: '未找到教程',
        emptySub: '尝试其他分类，或在有权限时创建新教程。',
        filterAll: '全部',
        filterBypass: '绕过',
        filterSetup: '安装',
        filterTroubleshoot: '排障',
        filterAria: '教程筛选',
    },
    modules: {
        browserControl: '浏览器控制',
        workspaceHint: '按你的方式配置模块。',
        connected: '已连接',
        waiting: '等待客户端连接',
        stopped: '已停止',
        globalSettings: '全局设置',
        globalHint: '应用于所有模块的偏好设置。',
        settingsHint: '调整设置后会自动保存更改。',
        saving: '正在保存…',
        saved: '所有更改已保存',
        saveFailed: '无法保存更改，请重试。',
        more: '更多',
        library: '模块列表',
        search: '搜索模块…',
        active: '已启用',
        enabled: '已启用',
        disabled: '已禁用',
        toggleModule: '启用 {name}',
        noResults: '没有匹配的模块。',
        chooseModule: '选择要配置的模块',
        keybind: '快捷键',
        keybindHint: '设置快捷键以在游戏中切换此模块。',
        boundHint: '在游戏中按 {key} 切换，或清除快捷键以使用浏览器控制。',
        bindingHint: '按下要绑定的按键。Escape 清除快捷键。',
        pressKey: '请按键…',
        notBound: '未绑定',
        clear: '清除',
        retry: '重试',
        ready: '准备好即可开始',
        startWorkspaceHint: '在此启动会话，然后连接 Dream 客户端以管理模块。销毁会结束会话。',
        categories: { all: '全部', combat: '战斗', visual: '视觉', utility: '实用' },
        themes: { cards: '卡片', wide: '宽卡片', workspace: '工作区' },
        expandSettings: '展开 {name} 设置',
        collapseSettings: '收起 {name} 设置',
        inGame: '游戏内',
        boundTo: '绑定到 {key}',
        title: '模块',
        running: '运行中',
        notConnected: '未连接',
        start: '启动',
        destruct: '销毁',
        switchTheme: '切换主题',
        popOut: '弹出窗口',
        publishConfig: '发布配置',
        startHint:
            '为防止被检测，必须先在 Web-GUI 中启动 Dream — 点击启动。若要避免继续被检测，请点击销毁以停止作弊功能。',
        toastStartFailed: '更改启动状态失败',
        toastLoadFailed: '加载模块失败',
    },
    gifts: {
        eyebrow: '礼物许可证',
        title: '有人给你送了 Dream',
        goHome: '返回首页',
        alreadyRedeemed: '此礼物已被兑换。',
        loginHint: '登录或注册账户以兑换此礼物。',
        redeem: '兑换礼物',
        openDashboard: '打开控制台',
        notFound: '未找到礼物',
        toastSuccess: '礼物已兑换 — 欢迎使用 Dream',
        toastFailed: '无法兑换礼物',
        productLine: 'Dream {product} · {plan}',
    },
    storefront: {
        eyebrow: '授权经销商',
        sub: '兑换从此经销商购买的 Dream 许可证密钥。',
        keyLabel: '许可证密钥',
        loginHint: '登录或注册以兑换。我们会把你带回这里。',
        redeem: '兑换密钥',
        notFound: '未找到店铺',
        toastSuccess: '密钥已兑换',
        invalidKey: '密钥无效或已被使用',
    },
    banned: {
        code: '已封禁',
        title: '你的账户已被封禁，无法访问 Dream Client。',
        submitLabel: '提交解封申诉',
        deniedHint: '你之前的申诉被拒绝{note}。你可以提交新的申诉。',
        deniedNote: '：{note}',
        countryLabel: '国家',
        countryPlaceholder: '你所在的国家/地区？',
        ispLabel: 'ISP / 网络运营商',
        ispPlaceholder: '例如：中国电信、Comcast、Starlink…',
        whyBannedLabel: '你认为账号为何被封？',
        whyBannedPlaceholder: '说明你认为导致封禁的原因…',
        sharedLabel: '你是否与他人共享过账号？',
        sharedYes: '是',
        sharedNo: '否',
        sharedRequired: '请选择是否共享过账号。',
        messagePlaceholder: '其他补充说明（可选）…',
        additionalLabel: '补充说明（可选）',
        submit: '提交申诉',
        staffNote: '员工备注：',
        replyPlaceholder: '回复员工…',
        sendReply: '发送回复',
        submitNew: '提交新申诉',
        statusOpen: '审核中',
        statusAccepted: '已接受',
        statusDenied: '已拒绝',
        loadReasonFailed: '无法加载封禁原因',
        toastLoadFailed: '加载申诉失败',
        toastAccepted: '申诉已通过 — 欢迎回来！',
        toastSubmitted: '申诉已提交',
        toastSubmitFailed: '提交申诉失败',
        toastReplyFailed: '发送回复失败',
    },
    assistant: {
        eyebrow: '快速帮助',
        title: '不确定选哪个方案？',
        sub: '几个简单问题 — 我们会推荐最合适的方案。',
        skip: '跳过',
        launch: '不确定选哪个方案？获取推荐',
        qVersion: '你玩哪个 Minecraft 版本？',
        qPlaystyle: '你最看重什么？',
        qCommitment: '你想如何开始？',
        qProduct: '哪个产品适合你？',
        combat: 'PvP / 战斗',
        visuals: '视觉 / ESP',
        utility: '实用 / QoL',
        everything: '都想要一点',
        tryMonthly: '先试月付',
        buyLifetime: '购买终身',
        giftFriend: '送给朋友',
        basicTitle: 'Dream Basic',
        basicSub: 'Web GUI · 面向 1.7–1.8',
        advancedTitle: 'Dream Advanced',
        advancedSub: '也支持 1.7–1.8 · 更多菜单',
        recommended: '为你推荐',
        giftBadge: '礼物',
        usePlan: '使用此方案',
        startOver: '重新开始',
        whyCombat: ' 若你优先 PvP / 战斗，很合适。',
        whyVisuals: ' 若你更看重 ESP / 视觉，很匹配。',
        whyUtility: ' 若你想要背包、宏与 QoL 工具，很稳妥。',
        whyEverything: ' 面向想要完整工具包的玩家。',
        whyBasic78: 'Dream Basic 面向 Minecraft 1.7–1.8（Web GUI）。',
        whyAdvanced78: 'Dream Advanced 也支持 1.7–1.8，并提供外部 + 内部菜单。',
        whyLegacy12: '1.12 由 Dream Advanced 支持（外部 + 内部菜单）。',
        whyModern: '1.20+ 需要 Dream Advanced（外部 + 内部菜单）。',
        whyGift: ' 礼物终身 — 好友登录后兑换链接。',
        whyMonthly: ' 月付可让你先试用再决定。',
        whyLifetime: ' 若打算长期使用，终身最划算。',
        productBasic: 'Dream Basic',
        productAdvanced: 'Dream Advanced',
    },
    becomeReseller: {
        badge: '经销商',
        title: '成为经销商',
        lead: "支付约 {'$'}{amount} 获取起步许可证包（{percent}% 折扣），然后在经销商面板出售密钥。",
        namePlaceholder: '经销商名称或网站',
        confirm: '我理解我将收到用于转售的许可证密钥，且此购买不可退款。',
        continue: '继续支付',
        totalDue: '应付总额：',
        toastCreateFailed: '创建激活发票失败',
        toastPaymentFailed: '创建支付失败',
        toastWelcome: '欢迎！经销商礼包已解锁。',
        toastVerifyFailed: '支付验证失败',
        toastPaypalFailed: '加载 PayPal 失败',
        toastPaymentUrlFailed: '获取支付链接失败',
        toastCryptoFailed: '创建加密货币支付失败',
        itemLabel: '{pkg} {plan}',
    },
    trustedResellers: {
        eyebrow: '支付选项',
        title: '我们的可信经销商',
        lead: '通过授权经销商使用银行卡、钱包、银行转账、加密货币等方式购买。购买后你会收到后续步骤的邮件。',
        altMethods: '+ 其他支付方式',
        empty: '当前没有可用的可信经销商。请稍后再试或使用其他支付方式。',
        visit: '访问 {name}',
        loadError: '无法加载可信经销商。请重试。',
        methodsAria: '接受的支付方式',
        sitesAria: '经销商网站',
        methodCard: '借记 | 信用卡 | 预付卡',
        methodApple: 'Apple Pay',
        methodGoogle: 'Google Pay',
        methodBank: '银行转账（美国、SEPA Direct）',
        methodCashApp: 'CashApp',
        methodCrypto: '加密货币',
        methodIdeal: 'iDEAL',
    },
    cryptoCheckout: {
        title: '加密货币支付',
        subtitle: '留在 Dream — 选择币种并发送准确金额。',
        pickCoin: '选择加密货币',
        popular: '热门',
        allCoins: '全部币种',
        search: '搜索币种…',
        continue: '继续',
        selected: '已选',
        sandbox: '沙盒',
        sandboxCase: '测试场景',
        sendExactly: '请准确发送',
        toAddress: '到此地址',
        copyAddress: '复制地址',
        copied: '地址已复制',
        fiatTotal: '订单总额',
        status: '状态',
        waiting: '等待付款',
        confirming: '确认中…',
        successTitle: '付款已收到',
        successBody: '你的访问权限正在解锁。你可以继续前往控制台。',
        goDashboard: '前往控制台',
        failedTitle: '付款失败',
        failedBody: '此付款未完成。你可以换用其他币种重试。',
        retry: '重试',
        close: '关闭',
        creating: '正在创建付款…',
        expires: '过期时间',
        note: '请仅向此地址发送所选币种。网络确认付款后访问权限将解锁。',
    },
    dialogs: {
        inputPlaceholder: '值',
    },
    message: {
        eyebrow: '公告',
        title: '收到消息',
    },
    migrate: {
        title: '欢迎回来！',
        body: '老用户你好 — Dream Client 有新更新，现在需要提供邮箱用于安全与密码重置。在添加邮箱前你将无法使用 Dream Client。',
        success: '已发送确认邮件 — 请查收收件箱。',
        submit: '发送确认',
        toastFailed: '发送验证失败',
    },
    verifyEmail: {
        verifying: '正在验证邮箱…',
        toastFailed: '验证邮箱失败',
    },
    notFound: {
        title: '页面未找到',
        text: '无法找到请求的页面。',
        cta: '返回首页',
    },
    referrals: {
        eyebrow: '媒体计划',
        title: '推广',
        sub: '每有一位用户使用你的推广码注册 Dream，你即可获得收益。',
        openTicket: '打开工单',
        currentUses: '当前使用次数',
        totalUses: '总使用次数',
        availableEarnings: '可提现收益',
        withdrawAt: '起提金额',
        empty: '此用户尚未关联推广账户。',
        linkEyebrow: '你的链接',
        shareTitle: '分享并赚取',
        shareText: '把此链接发给你的受众。达到 {amount} 后即可提现——然后在「{category}」分类下打开工单。',
        withdrawReady: '你已达到最低提现金额。请打开工单以领取收益。',
        copyLink: '复制推广链接',
        howItWorks: '运作方式',
        payoutsTitle: '结算',
        step1: '通过你的推广码加入的用户会计入你的使用次数。',
        step2: '收益在达到 {amount} 后解锁。',
        step3: '通过「{category}」分类下的工单申请提现。',
        loadError: '加载推广收益失败',
    },
    media: {
        hero: {
            title: '展示 Dream 的实战效果。',
            titleAccent: '获得创作许可。',
            copy: '制作展示 Dream 的 Minecraft 视频、短片或直播。通过审核的创作者可按约定的内容计划换取限时产品使用许可，并获得媒体团队的直接支持。',
            signIn: '登录并申请',
            startApplication: '开始申请',
            openWorkspace: '打开工作区',
            assurance: '许可将与你的 Dream 账户及内容计划绑定',
            create: '创作',
            publish: '发布',
            grow: '成长',
            caption: '许可 · 创作 · 发布',
        },
        overview: {
            title: '选择适合你频道的创作者级别',
            copy: '我们不要求每周或每月固定发布数量。准备好再发布：试用创作者每条审核通过的视频增加 1 周，成熟创作者增加 1 个月；媒体合作伙伴的媒体角色将持续有效。',
            affiliateBadge: '媒体 + 推广',
            licenseWindow: '许可期限',
            accessRenewal: '访问续期',
        },
        tiers: {
            trial: {
                name: '试用创作者',
                range: '50–500 名受众',
                copy: '使用 2 天初始许可录制你的第一条 Dream 视频。团队审核通过后，你的许可将延长 1 周。',
                start: '2 天初始许可',
                renewal: '每条审核通过的视频：增加 1 周访问权限',
            },
            established: {
                name: '成熟创作者',
                range: '500 名以上受众',
                copy: '使用 1 周初始许可制作 Dream 视频。团队审核通过后，你的许可将延长 1 个月。',
                start: '1 周初始许可',
                renewal: '每条审核通过的视频：增加 1 个月访问权限',
            },
            partner: {
                name: '媒体合作伙伴',
                range: '高度匹配的频道',
                copy: '获得持续创作访问权限的媒体角色，并使用推广链接和佣金结算。审核通过的 Dream 视频会记录在你的合作动态中。',
                start: '媒体角色访问权限',
                renewal: '记录审核通过的视频；媒体角色持续有效',
            },
        },
        guest: {
            title: '准备好展示 Dream 了吗？',
            copy: '使用你的 Minecraft 频道申请。通过审核后，我们会与你约定许可期限及你将发布的 Dream 内容。',
            createAccount: '创建账户',
        },
        intake: {
            closedTitle: '媒体申请目前已关闭',
            closedFallback: '新的 Dream Media 申请暂时不可用，现有创作者工作区仍可访问。',
        },
        apply: {
            title: '向我们介绍你的 Minecraft 频道。',
            copy: '这些信息帮助我们判断受众匹配度、设定许可期限，并约定可实现的内容交付。',
            steps: {
                channel: '频道',
                channelCopy: '你在哪里发布 Minecraft 内容',
                plan: '内容计划',
                planCopy: '你会如何展示 Dream',
                review: '许可审核',
                reviewCopy: '我们根据交付内容配置访问权限',
            },
            channelProfile: '频道资料',
            primaryPlatform: '主要平台',
            other: '其他',
            channelName: '频道名称',
            channelNamePlaceholder: '你的创作者名称',
            channelUrl: '频道网址',
            followers: '关注者 / 订阅者',
            typicalViews: '每条内容的通常播放量',
            contentLanguage: '内容语言',
            languagePlaceholder: '中文、英语…',
            categories: '内容分类',
            categoriesPlaceholder: 'Minecraft、PvP、教程…',
            fitTitle: '内容与许可匹配',
            experience: '介绍你的内容创作经验',
            experiencePlaceholder: '你创作了多久？哪类内容表现最好？',
            motivation: '为什么想加入 Dream Media？',
            motivationPlaceholder: '为什么 Dream 适合你的 Minecraft 受众？',
            feature: '你会如何展示 Dream？',
            featurePlaceholder: '分享视频、Shorts、TikTok 或直播创意，以及可实现的发布计划。',
            agreement: '我确认以上信息准确，并理解每次许可延期都需要 Dream 团队审核通过一条已发布的视频。',
            submitting: '正在提交…',
            submit: '提交申请',
        },
        workspace: {
            titleDefault: '媒体合作伙伴工作区',
            titles: {
                submitted: '你的申请正在处理中。',
                under_review: '你的申请正在处理中。',
                needs_info: '你的申请需要回复。',
                accepted: '欢迎加入 Dream Media。',
                declined: '你的申请已完成审核。',
                closed: '你的申请已关闭。',
            },
            copies: {
                submitted: '直接在账户中查看进度并与团队沟通。',
                under_review: '直接在账户中查看进度并与团队沟通。',
                needs_info: '团队需要先向你确认一个问题，然后才能作出决定。',
                accepted: '管理许可期限、内容交付、后续事项，以及你与 Dream 团队的持续合作。',
                declined: '在下方查看决定。准备好后，你可以提交一份更完善的新申请。',
                closed: '请查看下方的关闭原因。申请重新开放后，你可以创建新的申请。',
            },
            applicationNumber: '申请 #{id}',
            progress: '申请进度',
            submitted: '已提交',
            review: '审核',
            decision: '决定',
            partnership: '合作',
            needsInfoTitle: '团队需要更多信息',
            needsInfoCopy: '请阅读下方最新动态，并在对话中回复。',
            declinedTitle: '本次申请未通过',
            declinedFallback: '团队决定不继续推进这份申请。',
            closedTitle: '申请已关闭',
            closedFallback: 'Dream 团队关闭了此申请，但未将其标记为拒绝。',
            reapply: '创建新申请',
            activeRoleCopy: '你的媒体角色已启用。产品许可访问权限将按照你与 Dream 团队约定的内容计划提供。',
            starterAccessCopy: '你的 {product} 初始许可已启用，适用于你与 Dream 团队约定的内容计划。',
            basicProduct: 'Dream Basic',
            advancedProduct: 'Dream Advanced',
            licenseExpires: '许可到期时间',
            lifetimeAccess: '已有终身访问权限',
            lifetimeAccessCopy: '你现有的终身许可无需延期。你仍可提交已发布内容，供团队审核并记录在计划中。',
            licenseRenewalCopy: '提交已发布的 Dream 视频供团队审核，通过后即可获得对应级别的访问延期。',
            nextFollowUp: '下次跟进',
            notScheduled: '尚未安排',
            followUpCopy: '团队会在你的动态中发布日程变更。',
            affiliateSystem: '推广佣金结算系统',
            creatorLink: '创作者链接',
            preparingCode: '正在准备你的代码',
            affiliateCopy: '你可在“推广”中使用带追踪的推广链接和佣金结算工具。',
            referralCopy: '你可从侧边栏进入推广工作区。',
            conversation: '申请对话',
            updateCount: '{count} 条动态',
            dreamTeam: 'Dream 团队',
            viewContent: '查看已提交内容',
            contentPending: '等待审核',
            contentApproved: '已通过',
            extendedUntil: '许可已延长至 {date}',
            approvedNoExtension: '已通过，无需延长限时许可',
            messagePlaceholder: '给 Dream 媒体团队留言…',
            sendMessage: '发送消息',
            submitContentTitle: '提交已发布内容',
            submitContentCopy: '在此分享每条已上线的视频或帖子，方便团队审核和跟进。',
            publishedUrl: '已发布内容的网址',
            noteOptional: '备注（可选）',
            notePlaceholder: '补充背景、数据结果或团队需要了解的其他信息。',
            submitContent: '提交内容',
            channelSnapshot: '频道概览',
            platform: '平台',
            audience: '受众',
            typicalViews: '通常播放量',
            language: '语言',
            categories: '分类',
            applied: '申请时间',
            legacyTitle: '你的媒体访问权限已启用。',
            legacyCopy: '你的账户已有 Dream Media 角色。你可以从控制面板使用推广、下载、配置和创作者资源。',
            openReferrals: '打开推广',
        },
        status: {
            submitted: '已提交',
            under_review: '审核中',
            needs_info: '需要回复',
            accepted: '已通过',
            declined: '未通过',
            closed: '已关闭',
        },
        program: {
            onboarding: '加入流程中',
            active: '已启用',
            paused: '已暂停',
            inactive: '未启用',
            invited: '已邀请',
        },
        messages: {
            loadError: '无法加载媒体中心',
            applicationSubmitted: '你的媒体申请已提交',
            applicationError: '请检查填写内容后重试。',
            messageSent: '消息已发送',
            messageError: '消息发送失败',
            contentSubmitted: '内容已提交审核',
            contentError: '内容提交失败',
        },
    },    footer: {
        product: '产品',
        account: '账户',
        community: '社区',
        terms: '服务条款',
        rights: '保留所有权利。',
        disclaimer: 'Dream 与 Mojang AB 或 Microsoft 没有任何关联。',
    },
};
